import React from 'react';
import Loadable from 'react-loadable';
import { LoadingIndicator } from 'web-ui-kit/loading';

export default Loadable.Map({
  loader: {
    Shop: () => import('./ModsyShopController' /* webpackChunkName: "ModsyShop" */),
    Checkout: () => import('shared/components/Checkout' /* webpackChunkName: "Checkout" */)
  },
  loading: LoadingIndicator,
  render (loaded, props) {
    if (!props.stripeInstance) {
      return <LoadingIndicator isLoading />;
    }

    const Shop = loaded.Shop.default;
    return <Shop {...props} />;
  }
});
